import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsClickupComponent } from './simple-icons-clickup.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsClickupComponent ],
    exports:      [ SimpleIconsClickupComponent ],
    bootstrap:    []
})
export class SimpleIconsClickupModule {}
